module.exports = __webpack_public_path__ + "img/logo9.d4e72dc0.png";